/* eslint-disable import/prefer-default-export */

import { createContext } from 'react';

const context = typeof window !== 'undefined' ? window : null;

export const WindowContext = createContext(context);
